import { useState } from "react";
import { Loader2, Lock, Mail } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { adminApi, setToken, errText } from "./api";
import { inputCls } from "./Fields";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      setToken(data.token);
      onLogin(data.user);
    } catch (ex) {
      setErr(errText(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative min-h-screen grid place-items-center overflow-hidden bg-[#07061f] px-5 text-white">
      <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 h-[32rem] w-[32rem] rounded-full moon opacity-20 blur-2xl" />
      <form onSubmit={submit} className="relative w-full max-w-sm rounded-3xl border border-white/[0.08] bg-white/[0.04] backdrop-blur-2xl p-8 shadow-[0_30px_80px_rgba(0,0,0,0.5)]" data-testid="admin-login-form">
        <img src="/img/logo-t.png" alt="Dolunay TV" className="h-11 w-auto" />
        <h1 className="mt-8 font-display text-2xl font-bold">Yönetim Paneli</h1>
        <p className="mt-1 text-sm text-[#c9c6f0]">Devam etmek için giriş yap.</p>
        <div className="mt-7 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-[#c9c6f0] text-[11px] font-semibold uppercase tracking-[0.14em]">E-posta</Label>
            <div className="relative">
              <Mail size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#a4a6ff]" />
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className={`${inputCls} pl-10`} data-testid="admin-login-email" />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="text-[#c9c6f0] text-[11px] font-semibold uppercase tracking-[0.14em]">Şifre</Label>
            <div className="relative">
              <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#a4a6ff]" />
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className={`${inputCls} pl-10`} data-testid="admin-login-password" />
            </div>
          </div>
          {err && <p className="rounded-xl bg-red-500/10 border border-red-500/20 px-3 py-2 text-sm text-red-300" data-testid="admin-login-error">{err}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-b from-[#6c70ff] to-[#5b5fd6] h-11 font-semibold shadow-[0_8px_30px_rgba(91,95,214,0.4)] hover:brightness-110 transition-[filter] disabled:opacity-60">
            {busy && <Loader2 size={16} className="animate-spin" />} Giriş Yap
          </button>
        </div>
      </form>
    </div>
  );
};
